import type { StateCreator } from "zustand";

export type HoverTarget = "plot" | "band";

export interface HoverTimeSlice {
    timestamp: number | null;
    /** Which grid of the hovered panel the pointer is in. */
    hoverTarget: HoverTarget | null;
    setTimestamp: (timestamp: number | null, hoverTarget?: HoverTarget | null) => void;
}

export const createHoverTimeSlice: StateCreator<HoverTimeSlice, [], [], HoverTimeSlice> = (set) => ({
    timestamp: null,
    hoverTarget: null,
    setTimestamp: (timestamp, hoverTarget = null) => set({ timestamp, hoverTarget }),
});
